import React from 'react';
import PropTypes from 'prop-types';
import { StyledPlayText } from './PlayText.styles';

export const TYPES = {
    MINI: 'MINI',
    SMALL: 'SMALL',
    DEFAULT: 'DEFAULT',
    LARGE: 'LARGE',
    XLARGE: 'XLARGE',
    XXLARGE: 'XXLARGE',
};
const PlayText = ({ color, type, weight, underline, children, className, error, dataRt, as }) => (
    <StyledPlayText
        weight={weight}
        color={color}
        type={type}
        underline={underline}
        className={className}
        error={error}
        data-rt={dataRt}
        as={as}
    >
        {children}
    </StyledPlayText>
);
PlayText.propTypes = {
    color: PropTypes.string,
    type: PropTypes.oneOf(['MINI', 'SMALL', 'DEFAULT', 'LARGE', 'XLARGE']),
    underline: PropTypes.bool,
    children: PropTypes.node,
};
export default PlayText;
